import { Component, OnChanges, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { I18nService } from '@app/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnChanges {
  logoImage = '/v1/tenants/logo';

  constructor(
    private i18nService: I18nService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() { }

  ngOnChanges() {
  }

  setLanguage(language: string) {
    this.i18nService.language = language;
  }

  get currentLanguage(): string {
    return this.i18nService.language;
  }

  get languages(): string[] {
    return this.i18nService.supportedLanguages;
  }

  showNav(): boolean {
    let route = this.route;
    while (route.firstChild) {
      route = route.firstChild;
    }
    if (route && route.outlet === 'primary') {
      const showNav = route.snapshot.data.showNav;
      return showNav === undefined ? true : !!showNav;
    }
    return true;
  }

}
